module.exports = __webpack_public_path__ + "img/stock7.1951bb00.png";